import styled, { css } from 'styled-components'
import { ProgressIndicatorProps } from './types'

export const ProgressBarLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 251px;
  margin-bottom: 8px;
  user-select: none;
`

export const CurrentStep = styled.span`
  color: ${props => props.theme.colors.main.ultraViolet};
  font-size: 18px;
  font-weight: bold;
`

export const ProgressContainer = styled.div`
  background-color: ${props => props.theme.colors.shades.neutral[0]};
  border-radius: 8px;
  width: 251px;
  height: 16px;
`

export const ProgressIndicator = styled('div')<ProgressIndicatorProps>`
  border-radius: 45px;
  height: 16px;
  width: 0%;

  ${props =>
    props.color === 'ultraViolet' &&
    css`
      background-color: ${props.theme.colors.main.ultraViolet};
    `}

  ${props =>
    props.color === 'warning' &&
    css`
      background-color: ${props.theme.colors.main.warning};
    `}

  ${props =>
    props.color === 'green' &&
    css`
      background-color: ${props.theme.colors.main.green};
    `}

  ${props =>
    props.percentValue &&
    css`
      width: ${props.percentValue}%;
    `}
`
